/**
 * Converts API-relative media paths into absolute URLs. Full http(s) URLs pass through.
 */
export function resolveTenantMediaUrl(url: string | null | undefined): string | null {
  if (url == null) return null;
  const trimmed = String(url).trim();
  if (trimmed === '') return null;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const base = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'https://appointments.codeclutch.tools/api/v1';

  try {
    const origin = new URL(base).origin;
    return trimmed.startsWith('/') ? `${origin}${trimmed}` : `${origin}/${trimmed}`;
  } catch {
    return trimmed;
  }
}
